module.exports = __webpack_public_path__ + "img/thumbfly1.c474858a.png";